/**
 * Description — the workshop-type description block in the publish modal.
 *
 * Extracted from PublishConfirmModal so each file declares one component
 * (`react/no-multi-comp`); behaviour is unchanged.
 */
export function Description({ text }: { text: string }) {
  return (
    <p style={{ margin: 0, fontSize: 13, lineHeight: 1.5, color: 'var(--nb-muted)' }}>{text}</p>
  );
}

/**
 * What the When row can show, plus a warning when it can't show all of it.
 * Publishing is irreversible and this summary is what the operator confirms
 * against, so an unpopulated venue-local column must say so in words — it used
 * to render "— · — · —" and read as decoration.
 */
